import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../../hooks/useThemeColors";
import ModuleLimitsNew from "../../../settings/modules/partials/ModuleLimitsNew";

const ManageSubscriptionLimits = ({ isActive, selectedSubscription }) => {
  const { t } = useTranslation();
  const { textPrimaryMode, newBorderMode, white } = useThemeColors();

  // console.log("subscription", subscription)
  return (
    <>
      <Flex w="100%" gap="0rem" direction="column" m="1.5rem 0 0">
        <Flex
          w="100%"
          align="center"
          justify="flex-end"
          gap="0rem"
          p="0 0 0rem"
          direction="column"
        >
          <Box w="100%" m="0rem 0 0">
            <Text
              fontSize="0.875rem"
              fontWeight="600"
              color={textPrimaryMode}
              m="0 0 0.5rem"
            >
              {t("module.usageDetails")}
            </Text>

            <Box
              direction="column"
              w="100%"
              bg={white}
              borderRadius="1rem"
              // p="1.5rem"
            >
              <Flex
                w="100%"
                border={`1px solid ${newBorderMode}`}
                p="1.5rem"
                borderRadius="1rem"
                direction="column"
              >
                <Box p="0rem 0 0">
                  <ModuleLimitsNew
                    isActive={true}
                    moduleName={selectedSubscription.name}
                    plan={selectedSubscription.plan}
                    nextBillingDate={selectedSubscription.nextBillingDate}
                  />
                </Box>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default ManageSubscriptionLimits;
